module.exports = __webpack_public_path__ + "static/media/ourStory.3d8c4c99.svg";